// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2l4t8","transMoveUp":"transMoveUp--V6zoi","a":"a--1hVVQ","b":"b--1Xyrs","offset":"offset--2Dgsb","span":"span--Kj1zI"};